/*
* Checkout (Order Summary) adjustments
*/


// add content & adjust donation ask

$('.tn-donationAskCheckout-component').prepend('<div class="tn-donationAskCheckout-component__content"><div class="tn-donationAskCheckout-component__image"></div><div class="tn-donationAskCheckout-component__text"><h2>Help make Shakespeare accessible to everyone. As an independent charity, every donation helps more people experience the power of live theatre. Your support makes a real difference.</h2></div><button id="close-donation" class="btn btn--close-donation">Dismiss</button></div>')

$('#tnc-donation-form .component-actions').append('<p class="tn-donationAskCheckout-component__support-text"><b>Every donation</b>, no matter the amount, is greatly appreciated.</p>');

$('#tnc-donation-form #tnc-roundup').trigger('click');

$('#tnc-accept').html('<i class="fal fa-heart" aria-hidden="true"></i> Add donation & continue <i class="fal fa-arrow-right" aria-hidden="true"></i>');

/**
 * Pushes an event to the dataLayer for tracking purposes.
 * @param {string} event 
 * @returns {void}
 */
function addDataLayerEvent(event) {
  if (typeof event !== 'string' || event.length === 0) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': event
  });
}

$('#close-donation').on("click", function (event) {
  event.preventDefault();
  addDataLayerEvent('dismiss_donation');
  $('.tn-donationAskCheckout-component').addClass('hidden');
});

$('#tnc-accept').on("click", function (event) {
  addDataLayerEvent('add_donation');
});
